import { Icon, tokens } from "@vintecc/components";
import { faSpinner } from "@vintecc/pro-light-svg-icons";

interface LoaderProps {
  size?: "sm" | "md";
  className?: string;
}

export const Loader = ({ size = "sm", className }: LoaderProps) => {
  return <Icon icon={faSpinner} spin style={{ fontSize: size === "sm" ? "30px" : "60px" }} color={tokens.color.grey[400]} className={className} />;

  //return <Lottie loop animationData={loaderAnimation} style={sizes[size]} />;
};
